import { render, staticRenderFns } from "./DynamicPanels.vue?vue&type=template&id=5dcdd89c&scoped=true&"
import script from "./DynamicPanels.vue?vue&type=script&lang=js&"
export * from "./DynamicPanels.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPanels.vue?vue&type=style&index=0&id=5dcdd89c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdd89c",
  null
  
)

component.options.__file = "DynamicPanels.vue"
export default component.exports